// DeliverablesMultiSelect component for campaign creation
// Multi-select checkbox component for selecting campaign deliverables

import React from 'react';
import { DELIVERABLES, deliverableLabel, getAllDeliverableKeys } from '../../legacy/lib/deliverables.js';

const DeliverablesMultiSelect = ({ value = [], onChange, error }) => {
  const toggle = (key) => {
    const has = value.includes(key);
    if (has) {
      onChange(value.filter(v => v !== key));
    } else {
      onChange([...value, key]);
    }
  };

  const allKeys = getAllDeliverableKeys();

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        Deliverables <span className="text-red-500">*</span>
      </label>
      <div className="rounded-lg border border-gray-300 p-4 bg-white">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {allKeys.map((key) => (
            <label 
              key={key} 
              className="flex items-center gap-2 cursor-pointer hover:bg-gray-50 p-2 rounded transition-colors"
            >
              <input
                type="checkbox"
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                checked={value.includes(key)}
                onChange={() => toggle(key)}
              />
              <span className="text-sm text-gray-700">{deliverableLabel(key)}</span>
            </label>
          ))}
        </div>
      </div>
      {error && (
        <p className="text-sm text-red-600 mt-1">{error}</p>
      )}
      <p className="text-xs text-gray-500 mt-1">
        Select one or more. Keep scope realistic for the budget.
      </p>
    </div>
  );
};

export default DeliverablesMultiSelect;



